<template>
  <m-widget-betslip
    id="bet-slip"
    class="fon-bet-slip"
    open
  >
    <template slot="left-head">
      <div class="caption">{{ $t('bet-slip.bet-slip') }}</div>
    </template>
    <template slot="right-head">
      <bet-slip-settings v-if="$store.state.isUserLoggedIn" />
    </template>
    <bet-slip-warning v-if="!$store.state.isUserLoggedIn">
      {{ $t('bet-slip.warnings.guest.0') }}<br>
      <m-textito style="background: unset !important; color: white !important; border-radius: 10px;" @click="$store.commit('SHOW_MODAL', 'LOGIN')">{{ $t('bet-slip.warnings.guest.1') }}</m-textito>
      {{ $t('bet-slip.warnings.guest.2') }}
      <m-textito style="background: unset !important; color: white !important; border-radius: 10px;" @click="$store.commit('SHOW_MODAL', 'REGISTER')">{{ $t('bet-slip.warnings.guest.3') }}</m-textito>
    </bet-slip-warning>
    <div class="bet-slip-success-message" v-else-if="success && !positions.length">{{ success }}</div>
    <div v-else-if="!positions.length">
      <div>
        <svg height="12px" width="12px" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">
          <path d="m45.569 1.2191c-10.46 0-18.967 8.5065-18.967 18.967 0 7.9435 4.9121 14.75 11.854 17.57l-0.0098-2.7344c-5.5274-2.6533-9.3438-8.2836-9.3438-14.836 0-9.1092 7.3576-16.467 16.467-16.467s16.467 7.3576 16.467 16.467c0 6.5853-3.8552 12.239-9.4277 14.875v2.7227c6.9809-2.8018 11.928-9.6258 11.928-17.598 0-10.46-8.5065-18.967-18.967-18.967zm-0.017579 18.008c-3.2713 0-6.0209 2.5431-6.0117 5.748l0.09766 33.342-10.504-9.9824c-1.0381-0.98624-2.3801-1.4876-3.7051-1.4863-1.3249 0.0013-2.6322 0.50508-3.6035 1.5273l-0.5625 0.5918c-0.97442 1.0255-1.366 2.3805-1.2598 3.6523 0.10625 1.2718 0.65231 2.4801 1.4707 3.5176l17.529 22.223c0.0083 0.01092 0.06687 0.08936 0.14648 0.20703 0.08488 0.12546 0.17813 0.31914 0.14453 0.22852-0.01467-0.03959 0.05284 0.24701 0.07813 0.46484 0.02263 0.19507 0.03125 0.32012 0.0332 0.35156v3.8184h-2.9199c-0.99199 0-1.7688 0.64192-2.2129 1.3594-0.44414 0.71745-0.66211 1.5808-0.66211 2.5156v7.4414c0 0.93478 0.21797 1.7982 0.66211 2.5156 0.44414 0.71745 1.2209 1.3594 2.2129 1.3594h40.66c0.99199 0 1.7688-0.64192 2.2129-1.3594 0.44414-0.71745 0.66211-1.5808 0.66211-2.5156v-7.4414c0-0.93478-0.21797-1.7982-0.66211-2.5156-0.44414-0.71745-1.2209-1.3594-2.2129-1.3594h-2.7344c-0.04336-1.0225-0.14089-3.6564 0.0957-4.959 0.17433-0.95986 0.3084-1.0949 0.68164-1.832 0.37324-0.7371 0.88619-1.8771 1.5273-4.25 0.74471-2.7561 0.83621-8.301 0.84766-13.439 0.01145-5.1384-0.13476-9.6895-0.13476-9.6895 0.19058-3.1962-2.5367-5.7344-5.6016-5.7344-1.4097 0-2.69 0.54251-3.6719 1.4258-0.89593-1.9285-2.7667-3.2891-4.9727-3.2891-1.3916 0-2.6499 0.54271-3.6152 1.4258-0.89896-1.9174-2.7625-3.2676-4.9609-3.2676-1.1302 0-2.1715 0.35824-3.041 0.96484v-15.814c0-3.2007-2.7424-5.7441-6.0137-5.7441zm0 2.5c2.005 0 3.5137 1.4651 3.5137 3.2441v27.201a1.2501 1.2501 0 1 0 2.5 0v-6.5078c0-1.9191 1.3824-3.3438 3.041-3.3438 1.6586 0 3.0391 1.4247 3.0391 3.3438v1.627a1.2501 1.2501 0 0 0 0.0039 0.10547c-6.82e-4 0.03741-0.0059 0.07378-0.0059 0.11133v6.4766a1.2501 1.2501 0 1 0 2.5 0v-6.4766c0-1.9191 1.3805-3.3457 3.0391-3.3457 1.6586 0 3.041 1.4266 3.041 3.3457v1.7012a1.2501 1.2501 0 0 0 2e-3 0.05469c-7.1e-5 0.01185-2e-3 0.0233-2e-3 0.03516v6.375a1.2501 1.2501 0 1 0 2.5 0v-6.375c0-1.86 1.389-3.2734 3.1035-3.2734 1.7105 0 3.2586 1.4425 3.1074 3.1641a1.2501 1.2501 0 0 0-0.0039 0.14844s0.14415 4.5195 0.13281 9.6074c-0.01134 5.0879-0.2552 10.924-0.75976 12.791-0.60812 2.2506-1.014 3.1163-1.3457 3.7715-0.33175 0.65515-0.68946 1.3005-0.91016 2.5156-0.30511 1.6799-0.23292 4.0945-0.16406 5.4062h-29.978v-3.8477a1.2501 1.2501 0 0 0-2e-3 -0.07227s-0.01255-0.24118-0.04687-0.53711c-0.03433-0.29593-0.06105-0.62118-0.21875-1.0469-0.13924-0.37559-0.28698-0.56905-0.41602-0.75977-0.12903-0.19072-0.24414-0.33984-0.24414-0.33984a1.2501 1.2501 0 0 0-0.01172-0.01367l-17.529-22.223c-0.56106-0.71128-0.88694-1.5044-0.94336-2.1797-0.05641-0.67527 0.09894-1.2143 0.58008-1.7207l0.56445-0.5918c0.96846-1.0192 2.6202-1.0469 3.7734 0.04883l11.219 10.658c0.05792 0.09935 0.11383 0.20069 0.20703 0.31641 0.25449 0.31597 0.7925 0.80295 1.5918 0.76367 0.42212-0.02064 0.79315-0.24724 0.99609-0.45508 0.20294-0.20784 0.30043-0.3992 0.375-0.56836 0.14915-0.33831 0.2023-0.62592 0.24609-0.89648 0.08759-0.54113 0.0918-1.0273 0.0918-1.0273a1.2501 1.2501 0 0 0 2e-3 -0.02734l-0.09961-33.943c-0.0051-1.7747 1.5067-3.2402 3.5117-3.2402zm-9.0664 64.203h40.66c-0.09174 0-0.05541-0.0557 0.08789 0.17578 0.1433 0.23148 0.28711 0.67975 0.28711 1.1992v7.4414c0 0.51947-0.14381 0.96774-0.28711 1.1992s-0.17963 0.17578-0.08789 0.17578h-40.66c0.09174 0 0.05736 0.0557-0.08594-0.17578-0.1433-0.23148-0.28906-0.67975-0.28906-1.1992v-7.4414c0-0.51947 0.14576-0.96774 0.28906-1.1992s0.17767-0.17578 0.08594-0.17578z" stroke="" stroke-width="2px" fill="currentColor"></path>
        </svg>
        {{ $t('bet-slip.info') }}
      </div>
      <div>
        <span>
          <div v-show="!positions.length" class="switcher" :class="{ ' switcher--on': props.switcher }" @click="changeSwitcher">
            <div class="switcher__point"></div>
          </div>
          <span style="font-size: 11pt; margin-top: 12px; margin-right: 10px; position: absolute;">{{ $t('bet-slip.fast-bet') }} </span>
        </span>
        <span v-show="props.switcher" style="margin-left: 135px;">
          <input class="fast-bet-amount" type="text" v-model="fastBet"/>
          <span> {{ user.currency}}</span>
        </span>
      </div>
    </div>
    <div class="bet-slip-body" v-else-if="positions.length">
      <div class="bet-slip-error-message" v-if="error">
        <p>{{ error }}</p>
        <ul v-if="errorList.length">
          <li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
        </ul>
      </div>
      <div class="bet-slip-positions">
        <bet-slip-position v-for="position in positions" :key="[ position.event.id, position.id ].join(':')" :position="position" />
      </div>
      <bet-slip-options v-if="options.length > 1">
        <bet-slip-option v-for="option in options" :key="option.code" :option="option" />
      </bet-slip-options>
      <div class="bet-slip-info">
        <div class="flex bet-slip-info-item">
          <div class="label">{{ $t('bet-slip.total-stake') }}</div>
          <div class="value">{{ totalStake ? totalStake.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '0.00' }} {{ $store.state.user.currency }}</div>
        </div>
        <div class="flex bet-slip-info-item">
          <div class="label">{{ $t('bet-slip.maximum-return') }}</div>
          <div class="value">{{ maximumReturn ? maximumReturn.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '0.00' }} {{ $store.state.user.currency }}</div>
        </div>
      </div>
      <!-- опции ставки -->
      <div class="flex bet-slip-controls">
        <div class="left-flex">
          <color-button
            :disabled="false"
            color="yellow"
            @click="clear"
            style="background: #342d6e; color: white;"
          >
            <span style="float: left;">
              <i-trash-can-outline style="font-size: 20px; margin-top: 4px; margin-right: 5px;"/>
            </span>
            <span style="float: right;">
              {{ $t('favorites.clear-all') }}
            </span>
          </color-button>
        </div>
        <div class="right-flex">
          <color-button
            :disabled="false"
            color="yellow"
            @click="place"
          >
            {{ $t('bet-slip.place-bet') }}
          </color-button>
        </div>
      </div>
    </div>
    <div class="bet-slip-overlay" v-show="placing" />
  </m-widget-betslip>
</template>

<script>
import MTextito from '@/components/MTextito'
import MWidgetBetslip from '@/components/widget/MWidgetBetslip'
import Icon32 from '@/components/icons/Icon32'
import ColorButton from '@/components/buttons/ColorButton'
import BetSlipSettings from '@/components/fon-bet-slip/BetSlipSettings'
import BetSlipWarning from '@/components/fon-bet-slip/BetSlipWarning'
import BetSlipPosition from '@/components/fon-bet-slip/BetSlipPosition'
import BetSlipOptions from '@/components/bet-slip/BetSlipOptions'
import BetSlipOption from '@/components/bet-slip/BetSlipOption'
import ITrashCanOutline from 'vue-material-design-icons/TrashCanOutline'

import { mapState } from 'vuex'

export default {
  components: { MTextito, MWidgetBetslip, Icon32, ColorButton, BetSlipSettings, BetSlipWarning, BetSlipPosition, BetSlipOptions, BetSlipOption, ITrashCanOutline },
  computed: {
    ...mapState({
      positions: state => state.betSlip.positions,
      options: state => state.betSlip.options,
      totalStake: state => state.betSlip.totalStake,
      maximumReturn: state => state.betSlip.maximumReturn,
      placeable: state => state.betSlip.placeable,
      placing: state => state.betSlip.placing,
      user: state => state.user,
      quickBet: state => state.betSlip.quickBet,

      success: state => state.betSlip.success,
      error: state => state.betSlip.error,
      errorList: state => state.betSlip.errorList
    })
  },
  props: {
    switcher: false
  },
  data () {
    return {
      open: true,
      props: {
        switcher: false
      },
      fastBet: 100
    }
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('betSlip/UPDATE_POSITIONS')
    },
    'maximumReturn' (to, from) {
      if (this.$store.state.betSlip.fastBet && this.$store.state.betSlip.fBOn === 1) {
        this.$store.dispatch('betSlip/PLACE')
      }
    },
    'fastBet' (to, from) {
      this.$store.commit('betSlip/PUT_QUICK_BET', { on: this.quickBet.on, amount: this.fastBet })
    }
  },
  mounted () {
    if (this.quickBet.on === true) {
      this.props.switcher = true
      this.$store.commit('betSlip/PUT_QUICK_BET', { on: true, amount: this.quickBet.amount })
      this.fastBet = this.quickBet.amount
    } else {
      this.props.switcher = false
      this.$store.commit('betSlip/PUT_QUICK_BET', { on: false, amount: this.quickBet.amount })
      this.fastBet = this.quickBet.amount
    }
  },
  methods: {
    clear () {
      this.$store.commit('betSlip/CLEAR')
    },
    place () {
      this.$store.dispatch('betSlip/PLACE')
    },
    changeSwitcher () {
      if (this.props.switcher === false) {
        this.$store.commit('betSlip/PUT_QUICK_BET', { on: true, amount: this.fastBet })
        this.props.switcher = true
      } else {
        this.$store.commit('betSlip/PUT_QUICK_BET', { on: false, amount: this.fastBet })
        this.props.switcher = false
      }
      console.log(this.quickBet)
    }
  }
}
</script>

<style scoped>
.fon-bet-slip { border-bottom: 1px solid hsla(0,0%,100%,.07); padding: 0 10px; border: 2px solid #713592; margin-top: 10px; margin-left: 1px; margin-right: 10px; border-radius: 10px;}
.bet-slip-body { /* border-top: 2px solid black; padding: 0 10px; */ margin-bottom: 5px;  }
.bet-slip-overlay { display: none; background: rgba(0, 0, 0, .5); bottom: 0; left: -10px; position: absolute; right: -10px; top: 0; }
.bet-slip-success-message { background: #43a047; /* border-radius: 5px; */ padding: 10px; text-align: center; }
.bet-slip-error-message { background: #f44336; /* border-radius: 5px; */ margin-bottom: 10px; padding: 10px; }
.bet-slip-error-message ul { margin-left: 14px; }
.bet-slip-positions { display: flex; flex-direction: column; }
.bet-slip-position:not(:first-child) { margin-top: 5px; }
.bet-slip-info { margin: 10px 5px 0; }
.bet-slip-info-item { line-height: 24px; }
.bet-slip-info-item:not(:last-child) { border-bottom: 1px solid rgba(255, 255, 255, .07); }
.bet-slip-info-item .label { flex: 1 1; }
.bet-slip-controls { margin-top: 5px; /* padding-left: 9px; */ }
.bet-slip-clear-button { margin: -1px; cursor: pointer; }
.trash-can-outline { color: #ffdf1b; font-size: 24px; margin: 5px 0; }

.switcher--disabled {
    opacity: .5;
    pointer-events: none;
}
.switcher {
    display: inline-block;
    vertical-align: middle;
    border-radius: 1em;
    cursor: pointer;
    position: relative;
    z-index: 1;
    font-size: 10px;
    width: 3em;
    height: 2em;
    margin-top: 11px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-transition: background-color .2s 50ms;
    transition: background-color .2s 50ms;
    background-color: var(--switcher-track-background-color, gray);
    margin-right: 10px;
    margin-bottom: 20px;
}

.fast-bet-amount {
    border: 1px solid #713592;
    text-align: right;
    width: 100px;
    margin-left: 5px;
}

.switcher__point {
    left: .2em;
    top: .2em;
    width: 1.6em;
    height: 1.8em;
    border-radius: 50%;
    -webkit-transition: -webkit-transform .2s;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
    -webkit-box-shadow: 0 1px 4px rgba(0,0,0,.5);
    box-shadow: 0 1px 4px rgba(0,0,0,.5);
    background-color: #fff;
    margin-top: 1px;
}

.switcher.switcher--on .switcher__point {
    left: .2em;
    top: .2em;
    width: 1.6em;
    height: 1.8em;
    border-radius: 50%;
    -webkit-transition: -webkit-transform .2s;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
    -webkit-box-shadow: 0 1px 4px rgba(0,0,0,.5);
    box-shadow: 0 1px 4px rgba(0,0,0,.5);
    background-color: #fff;
    margin-top: 1px;
    float: right;
}

.switcher.switcher--on {
  background-image: linear-gradient(to top right,#713592,#342d6e) !important;
}

.fast-bet {
  background: hsla(0, 0%, 100%, .05);
  font-size: 14px;
  padding: 5px;
  position: relative;
  color: #cecece;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/fon-bet-slip/BetSlip.vue